import { Box, CircularProgress } from "@mui/material";
import toastACI from "components/toastACI";
import useStorage from "hooks/useStorage";
import client from "libs/client";
import SebNotif from "pages/SebPages/NotifSeb";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useToaster } from "rsuite";

const SebValidationWrapper = ({ children, isSaveStatusApp }) => {
  const toast = useToaster();
  const { setItem } = useStorage();

  const [returnComponent, setReturnComponent] = useState(
    <Box width="100vw" height="100vh" display="flex" justifyContent="center" alignItems="center">
      <CircularProgress />
    </Box>
  );

  const getSebStatus = async () => {
    try {
      const res = await client.requestAPI({
        endpoint: "api/v1/status-seb",
        isAuth: false,
      });
      if (res?.meta?.status === "Success") {
        if (
          res?.data?.isSafeExamBrowser &&
          !navigator.userAgent.includes("safeexambrowser-exam-dit-telkom")
        ) {
          setReturnComponent(<SebNotif />);
        } else {
          setReturnComponent(children);
        }

        if (isSaveStatusApp) {
          setItem("statusApp", res?.data, "session");
        }
      }
    } catch (error) {
      toast.push(
        toastACI({
          type: "error",
          header: "SEB Status",
          message: error?.response?.data?.message || error?.message || "Failed Get SEB Status",
        }),
        {
          placement: "topEnd",
        }
      );
    }
  };

  useEffect(() => {
    getSebStatus();
  }, []);

  return returnComponent;
};

SebValidationWrapper.defaultProps = {
  isSaveStatusApp: false,
};

SebValidationWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  isSaveStatusApp: PropTypes.bool,
};

export default SebValidationWrapper;
